export enum DataBaseNodes {
  IpApi = 'ipApi',
  Sites = 'sites',
  Request = 'request',
  Patients = 'patients',
  SiteList = 'siteList',
  SitesData = 'sitesData',
  IsDeleted = 'isDeleted',
  MaintenanceMode = 'maintenanceMode',
  CommunicationChannel = 'communicationChannel',
  DeviceIdentifier = 'DeviceIdentifier',
  PatientProfile = 'patientProfile',
  Responses = 'responses',
  QrCode = 'qrCode',
  QrCodeRequest = 'qrCode/request',
  Files = 'files',
  Reminders = 'reminders',
  Connection = 'connection',
  Wearables = 'wearables',
  TasksUpdate = 'TASKS_UPDATE',
  ChatHistory = 'chatHistory',
  DeviceToken = 'deviceToken',
  DeviceOS = 'deviceOS',
  ChatMessage = 'chatMessages',
  TypingStatus = 'typingStatus',
  Asset = 'assetCollection',
  Patient = 'patient',
  CareTeam = 'careTeam',
  ServerVersion = 'serverVersion',
  AccountReset = 'RESETED_AT',
}

export type PatientSites = Record<
  string,
  {
    assetId: number;
    firebasePatientID: string;
    firebaseProjectId: string;
    siteUUID: string;
  }
>;

export type PatientWearables = {
  lastDate: number;
  source: number;
};
